import React, {Component, ReactNode} from 'react'
import NatMaintenanceSettingMasterRepo from './/repository/NatMaintenanceSettingMasterRepo'
import {MESSAGE_TYPE, VALID_OR_NOT, VALID_OR_NOT_CHECK} from '../../../CodeMaster'
import {Nullable} from '../../../app/TypeHelpers'
import {PageFooterArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminDefaultButton, AdminSecondaryButton} from '../../../styledComponents/adminPage/Buttons'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import styled from 'styled-components'
import {Messages} from '../../../Messages'
import {Box, createTheme, DialogActions, DialogTitle, StyledEngineProvider, ThemeProvider} from '@mui/material'
import {
    FlexContainer,
    LeftColumnFlexContainer,
    LeftRowFlexContainer,
    RowFlexContainer,
} from '../../../styledComponents/FlexComponents'
import {createIconWithLevel} from '../../../styledComponents/adminPage/IconCreator'
import PPCheckboxGroup from '../../../components/shared/forms/PPCheckboxGroup'
import {FontSizeInPixel, FontWeights} from '../../../styledComponents/Constants'
import {
    NatPutMaintenanceForResident,
    NatPutMaintenanceSettingMasterParam,
} from './repository/NatPutMaintenanceForResident'
import {AsyncCommunicationProps} from '../../../components/shared/hoc/withAsyncCommunication'
import {Location, NavigateFunction} from 'react-router-dom'


// TODO: @mui/styles用 styled-componentsを使用するため削除してDefaultThemeはstyled-componentsの物を使用する
// declare module '@mui/styles/defaultTheme' {
//   // eslint-disable-next-line @typescript-eslint/no-empty-interface
//   interface DefaultTheme extends Theme {}
// }


interface Props {
    maintenanceSettingMasterRepo: NatMaintenanceSettingMasterRepo
    eventEmitter: EventEmitterExAdmin
    navigate: NavigateFunction,
    location: Location,
    currentValidFlag: string
    currentVersion: number
    updateButtonText: string
    onClickDialogCancelButton: () => void
}


interface States {
    checkedDescriptionFlag: string
}

export default class NatAdminMaintenanceForResidentDialog
    extends Component <Props & AsyncCommunicationProps, States> {

    constructor(props: Props & AsyncCommunicationProps) {
        super(props)

        this.state = {
            checkedDescriptionFlag: VALID_OR_NOT_CHECK.NOT.value,
        }

        this.onClickDialogCancelButton = this.onClickDialogCancelButton.bind(this)
        this.onChangeCheckedDescriptionFlag = this.onChangeCheckedDescriptionFlag.bind(this)
        this.onClockUpdateButton = this.onClockUpdateButton.bind(this)

    }

    async onClockUpdateButton(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        this.props.eventEmitter.closeDialog()
        try {

            const updateToValidFlag =
                this.props.currentValidFlag === VALID_OR_NOT.VALID.value ?
                    VALID_OR_NOT.NOT.value : VALID_OR_NOT.VALID.value
            const request: NatPutMaintenanceSettingMasterParam = {
                validFlag: updateToValidFlag,
                version: this.props.currentVersion,
            }

            const putMaintenanceSettingMasterResidentResponse: Nullable<NatPutMaintenanceForResident> =
                await this.props.asyncCallFunction(
                    this.props.maintenanceSettingMasterRepo.putMaintenanceSettingMasterResident.bind(
                        this.props.maintenanceSettingMasterRepo, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0002.toString('メンテナンス状態')},
                )

            if (putMaintenanceSettingMasterResidentResponse &&
                putMaintenanceSettingMasterResidentResponse.requestError === null) {

                this.props.navigate(this.props.location.pathname, {
                    state: {
                        registerComplete: true,
                    },
                })
                window.location.reload()

            } else {
                this.onClickDialogCancelButton()
            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    onClickDialogCancelButton(): void {
        this.props.onClickDialogCancelButton()
    }

    onChangeCheckedDescriptionFlag(): void {
        let checkedDescriptionFlag = this.state.checkedDescriptionFlag
        if (checkedDescriptionFlag === VALID_OR_NOT_CHECK.VALID.value) {
            checkedDescriptionFlag = VALID_OR_NOT_CHECK.NOT.value
        } else {
            checkedDescriptionFlag = VALID_OR_NOT_CHECK.VALID.value
        }
        this.setState({checkedDescriptionFlag})
    }

    getPossibleOrNotPossibleText(): string {
        let possibleNotPossible = '可能'
        if (this.props.currentValidFlag === VALID_OR_NOT.NOT.value) {
            possibleNotPossible = '不可'
        }
        return possibleNotPossible
    }

    render(): ReactNode {
        return <>
            <DialogTitle id="updateMaintenanceSettingMaster-dialog-title">
                <LeftRowFlexContainer>
                    {createIconWithLevel(MESSAGE_TYPE.WARNING)}設定内容の確認
                </LeftRowFlexContainer>
            </DialogTitle>
            <Box ml={'24px'}>設定の変更を行います。下記の内容をご確認ください。</Box>
            <InformationOnChangeBox>・居住者画面へのアクセスが{this.getPossibleOrNotPossibleText()}となります。</InformationOnChangeBox>
            <StyledCheckBoxContainer>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <PPCheckboxGroup
                            data={[{
                                label: '内容を確認したうえで、了承します。',
                                checked: this.state.checkedDescriptionFlag === VALID_OR_NOT_CHECK.VALID.value,
                            }]}
                            onChangeChecked={this.onChangeCheckedDescriptionFlag}
                        />
                    </ThemeProvider>
                </StyledEngineProvider>
            </StyledCheckBoxContainer>
            <DialogActions>
                <StyledPageFooterArea>
                    <PageFooterAreaLeft>
                        <MarginFlexContainer>
                            <CancelButton onClick={this.onClickDialogCancelButton}>
                                キャンセル
                            </CancelButton>
                        </MarginFlexContainer>
                    </PageFooterAreaLeft>
                    <PageFooterAreaRight>
                        <LeftColumnFlexContainer>
                            <UpdateButton
                                onClick={this.onClockUpdateButton}
                                disabled={this.state.checkedDescriptionFlag === VALID_OR_NOT_CHECK.NOT.value}>
                                居住者画面のメンテナンスを{this.props.updateButtonText}にする
                            </UpdateButton>
                        </LeftColumnFlexContainer>
                    </PageFooterAreaRight>
                </StyledPageFooterArea>
            </DialogActions>
        </>
    }
}

// @ts-ignore
const StyledCheckBoxContainer = styled(FlexContainer)`
  justify-content: center;
  background-color: #fce9c8;
  margin: 15px 24px 0 24px;
  padding: 10px 0;
`
const StyledPageFooterArea = styled(PageFooterArea)`
  margin: 15px 24px 16px 24px;
  padding: 0;
  align-items: flex-end;
`
const PageFooterAreaLeft = styled(RowFlexContainer)`
  justify-content: flex-end;
  flex-grow: 1;
  order: 1;
`
const PageFooterAreaRight = styled(RowFlexContainer)`
  justify-content: flex-start;
  flex-grow: 1;
  order: 2;
`
const MarginFlexContainer = styled(FlexContainer)`
  margin: 0 40px 0 140px;
`
const CancelButton = styled(AdminDefaultButton)`
  &.MuiButton-root {
    width: 315px;
  }
`
const UpdateButton = styled(AdminSecondaryButton)`
  &.MuiButton-root {
    width: 315px;
    background-color: #D7374A;
    color: #FFFFFF;
    box-shadow: 0 2px 0 #88222E;
    border-radius: 8px;
    font-size: ${FontSizeInPixel.Small};
    font-weight: ${FontWeights.Bold};
  }

  &.Mui-disabled {
    background-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.26);
    box-shadow: none;
  }
`
const InformationOnChangeBox = styled(Box)`
  border: 2px solid #dadde9;
  margin: 24px;
  padding: 12px;
`

const theme = createTheme({
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: '0.875rem!important',
                },
            },
        },
    },
})
